import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import UserGroupDropDown from "../Shared/UserGroupDropDown";
import SetupMenu from './SetupMenu';
import { scrollToTop } from '../Shared/ScrollOnTop';

function AddConcession(props) {
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState(false);

    let navigate = useNavigate();

    const handleSubmit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            setLoading(true);
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                Concession_Rule_Code: event.target.ConcessionRuleCode.value,
                Concession_Rule_Name: event.target.ConcessionRuleName.value,
                Concession_Percentage: event.target.ConcessionPercentage.value,
                Concession_Rule_Detail: event.target.ConcessionRuleDetail.value,
                ConcessionValue: event.target.ConcessionValue.value,
                School_ID: 1,
            };

            //console.log(data);

            var api_config = {
                method: 'post',
                url: config.base_url + 'Concession/AddConcessionRule',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };



            axios(api_config)
                .then(function (response) {
                    //console.log(response.data);
                    if (response.data.status_code == 1) {

                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });

                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }

                    setLoading(false);


                })
                .catch(function (error) {
                    setLoading(false);
                    toast.error('Network Error..', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });



        }

        setValidated(true);
    };
    return (
        <>
            <SetupMenu />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/Setup/SetupDashboard">Setup</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Add Concession Rule</li>
                                </ol>
                            </nav>
                            <div className="page-title">Add Concession Rule</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/Setup/ManageConcession" className="button button-white button-icon">
                                    Manage Concession Rules
                                    <i className="ri-list-check"></i>
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <div className="row align-items-center">
                                            <div className="col-md-2">
                                                <div className="form-group mb-3">
                                                    <label >Concession Code:</label>
                                                    <input type="text" className="form-control" required name="ConcessionRuleCode" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="">Concession Rule Name:</label>
                                                    <input type="text" className="form-control" required name="ConcessionRuleName" />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group mb-3">
                                                    <label className="">Concession Percentage:</label>
                                                    <input type="text" defaultValue={0} className="form-control" required name="ConcessionPercentage" />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group mb-3">
                                                    <label className="">Concession Amount:</label>
                                                    <input type="text" defaultValue={0} className="form-control" required name="ConcessionValue" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="">Concession Rule Detail:</label>
                                                    <input type="text" className="form-control" required name="ConcessionRuleDetail" />
                                                </div>
                                            </div>

                                            <div className="col-md-2 offset-md-10 text-end">
                                                <div className="form-group ">
                                                    {
                                                        loading ?
                                                            <Spinner animation="border" role="status"></Spinner>

                                                            :
                                                            <button type="submit" value="Save" className="button button-primary w-100 ">SAVE</button>

                                                    }

                                                </div>
                                            </div>

                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddConcession;
